import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "bg-Active" }
const _hoisted_2 = { class: "flex flex-col md:flex-row mb-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M241.935 35.5685H113.102C108.442 35.5685 104.66 30.5973 104.66 24.4556C104.66 18.3139 108.442 13.3428 113.102 13.3428H241.935C246.595 13.3428 250.377 18.3139 250.377 24.4556C250.377 30.5973 246.595 35.5685 241.935 35.5685ZM250.377 105.461C250.377 99.3265 246.595 94.3479 241.935 94.3479H113.102C108.442 94.3479 104.66 99.3265 104.66 105.461C104.66 111.595 108.442 116.574 113.102 116.574H241.935C246.595 116.574 250.377 111.595 250.377 105.461ZM200.473 64.9656C200.473 58.8239 196.691 53.8528 192.031 53.8528H8.44214C3.78208 53.8528 0 58.8239 0 64.9656C0 71.1073 3.78208 76.0784 8.44214 76.0784H192.025C196.691 76.0784 200.473 71.0999 200.473 64.9656ZM427.026 131.628C428.951 131.583 445.987 131.161 451.981 130.05C491.963 122.738 539.599 105.616 539.599 65.5805C539.588 26.1522 491.89 8.99398 451.902 1.54838C446.156 0.466736 429.289 0.0444513 427.234 0H271.392C266.732 0 262.95 4.97114 262.95 11.1128V120.411C262.95 126.545 266.727 131.524 271.387 131.524L426.863 131.635C426.919 131.628 426.97 131.628 427.026 131.628ZM279.835 22.2183H427.077C433.87 22.3738 445.954 22.8776 449.51 23.5518C493.28 31.7012 522.698 48.5927 522.709 65.5805C522.709 82.9758 493.348 100.038 449.64 108.039C445.875 108.735 433.949 109.232 426.79 109.402L279.835 109.298V22.2183Z",
  fill: "white"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col self-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-lg font-normal" }, "Create an account")
], -1)
const _hoisted_6 = { class: "flex flex-row mx-14 md:mx-20" }
const _hoisted_7 = {
  class: "flex flex-col w-full mb-10",
  id: "signup"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-xl font-light text-center text-green-200" }, " IMPORTANT: Signups are now open! ", -1)
const _hoisted_9 = { class: "text-white text-xl font-light mt-5 text-center text-red-500" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-base font-normal mt-10 mb-3" }, "Email", -1)
const _hoisted_11 = { class: "text-red-500 mb-3 font-light text-sm" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-base font-normal mt-10 mb-3" }, "Username", -1)
const _hoisted_14 = { class: "text-red-500 mb-3 font-light text-sm" }
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-base font-normal mt-10 mb-3" }, "Onetap Username", -1)
const _hoisted_17 = { class: "text-yellow-200 text-base font-light mb-3" }
const _hoisted_18 = { class: "text-red-500" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", { class: "text-red-500 mb-3 font-light text-sm" }, null, -1)
const _hoisted_20 = ["value"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-base font-normal mt-10 mb-3" }, "Onetap UID", -1)
const _hoisted_22 = { class: "text-yellow-200 text-base font-light mb-3" }
const _hoisted_23 = { class: "text-red-500" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h1", { class: "text-red-500 mb-3 font-light text-sm" }, null, -1)
const _hoisted_25 = ["value"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-base font-normal mt-10 mb-3" }, "Password", -1)
const _hoisted_27 = { class: "text-red-500 mb-3 font-light text-sm" }
const _hoisted_28 = ["value"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white text-base font-normal mt-10 mb-3" }, "Confirm Password", -1)
const _hoisted_30 = { class: "text-red-500 mb-3 font-light text-sm" }
const _hoisted_31 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("svg", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
        class: "md:ml-20 md:mx-0 mx-auto cursor-pointer",
        id: "logo",
        width: "200",
        height: "132",
        viewBox: "0 0 600 132",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, _hoisted_4)),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("form", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("h1", _hoisted_9, _toDisplayString(_ctx.globalError_Content), 1),
        _hoisted_10,
        _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.emailError_Content), 1),
        _createElementVNode("input", {
          value: _ctx.email,
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateEmail && _ctx.updateEmail(...args))),
          class: "px-3 py-3 placeholder-gray-400 relative bg-Third text-white rounded text-sm focus:ring-Secondary focus:ring-2 border-0 w-full",
          type: "text",
          placeholder: "Enter an email here."
        }, null, 40, _hoisted_12),
        _hoisted_13,
        _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.usernameError_Content), 1),
        _createElementVNode("input", {
          value: _ctx.username,
          onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateNormalUsername && _ctx.updateNormalUsername(...args))),
          class: "px-3 py-3 placeholder-gray-400 relative bg-Third text-white rounded text-sm focus:ring-Secondary focus:ring-2 border-0 w-full",
          type: "text",
          placeholder: "Enter a username here."
        }, null, 40, _hoisted_15),
        _hoisted_16,
        _createElementVNode("h1", _hoisted_17, [
          _createTextVNode(" Make sure your input is correct! You will not be able to change this after signup. "),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.onetapUserError_Content), 1)
        ]),
        _hoisted_19,
        _createElementVNode("input", {
          value: _ctx.onetap_username,
          onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.updateOTUsername && _ctx.updateOTUsername(...args))),
          class: "px-3 py-3 placeholder-gray-400 relative bg-Third text-white rounded text-sm focus:ring-Secondary focus:ring-2 border-0 w-full",
          type: "text",
          placeholder: "Enter your onetap username here."
        }, null, 40, _hoisted_20),
        _hoisted_21,
        _createElementVNode("h1", _hoisted_22, [
          _createTextVNode(" Make sure your input is correct! You will not be able to change this after signup. "),
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.onetapUIDError_Content), 1)
        ]),
        _hoisted_24,
        _createElementVNode("input", {
          value: _ctx.onetap_uid,
          onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateUID && _ctx.updateUID(...args))),
          class: "px-3 py-3 placeholder-gray-400 relative bg-Third text-white rounded text-sm focus:ring-Secondary focus:ring-2 border-0 w-full",
          type: "text",
          placeholder: "Enter your onetap UID here."
        }, null, 40, _hoisted_25),
        _hoisted_26,
        _createElementVNode("h1", _hoisted_27, _toDisplayString(_ctx.passwordError_Content), 1),
        _createElementVNode("input", {
          value: _ctx.password,
          onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.updatePassword && _ctx.updatePassword(...args))),
          class: "px-3 py-3 placeholder-gray-400 relative bg-Third text-white rounded text-sm focus:ring-Secondary focus:ring-2 border-0 w-full",
          type: "password",
          placeholder: "Enter a password here."
        }, null, 40, _hoisted_28),
        _hoisted_29,
        _createElementVNode("h1", _hoisted_30, _toDisplayString(_ctx.passwordConfirmError_Content), 1),
        _createElementVNode("input", {
          value: _ctx.passwordConfirm,
          onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.updatePasswordConfirm && _ctx.updatePasswordConfirm(...args))),
          class: "px-3 py-3 placeholder-gray-400 relative bg-Third text-white rounded text-sm focus:ring-Secondary focus:ring-2 border-0 w-full",
          type: "password",
          placeholder: "Confirm your password."
        }, null, 40, _hoisted_31),
        _createElementVNode("button", {
          onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args))),
          class: "text-white text-base font-light py-3 mt-20 bg-Third",
          id: "submit"
        }, " Signup ")
      ])
    ])
  ]))
}